import {
  AddGoodToCartType,
  CommonLoadParam,
  CommonStoreState,
  DefaultOpenPackageProductType,
  DefaultPageSize,
  DefaultSaleCardProductType,
  DeleteGoodToCartType,
  MIN_OPEN_PACKAGE_AMOUNT,
  RecommondType
} from './type';
/*
 * Copyright (c) 2019 3will Corporation and others.
 * All rights reserved. This program and the accompanying materials
 * are made available under the terms of the 3will License v1.0
 * which accompanies this distribution, and is available at
 *
 *     http://www.3will.cn/licenses/license-v1.0
 *
 * Contributors:
 *    3will - initial API and implementation
 */
import {
  BfAppContext,
  BfPageStore,
  ConditionDTO,
  ConditionRuleDTO,
  EnumValue,
  PageResDTO,
  newEqualCondition,
  newRuleCondition,
  newSortAsc,
  newSortDesc,
  promiseWait
} from '@tw/tw-runtime';
import {
  HrCheckInitDataModel,
  HrEmployeeService,
  HrInitDataModel,
  ProductAuditStatusEnumValue,
  ProductCategoryDTO,
  ProductCategoryRestApiService,
  ProductDocGoodsRestApiService,
  ProductGoodsDTO,
  ProductGoodsRestApiService,
  ProductGoodsService,
  ProductOnGoingWelfareModel,
  ProductProductRestApiService,
  ProductTypeEnumValue,
  ProductWelfareService,
  ResAddressDTO,
  ResAddressRestApiService,
  ResSupplierDTO,
  SaleDocOrderDTO,
  SaleDocOrderRestApiService,
  SaleOrderDTO,
  SaleOrderService
} from '@tw/clvip-api-gen';

import { ROUTE_NAMES } from '@/app/navigation/route-names';
import { navigationRef } from '@tw/tw-runtime-rn';

export class CommonStore extends BfPageStore<CommonStoreState> {
  private static instance = null;

  // 正在进行的活动
  private ongoingActivities: ProductWelfareService;

  // 审核通过
  private auditPassConditions: ConditionDTO[];

  // 当前员工制定活动下的订单查询
  private orderFuncService: SaleOrderService;

  // 商品service
  private productResetService: ProductProductRestApiService;
  private productDocGoodsService: ProductDocGoodsRestApiService;

  // 地址service
  private addressService: ResAddressRestApiService;

  // 商品service
  private productGoodsService: ProductGoodsRestApiService;

  // 自定义的
  private customProductGoodsService: ProductGoodsService;
  private priceSort: 'asc' | 'desc' = 'desc';

  private productCategoryService: ProductCategoryRestApiService;

  // 订单
  // private orderService: SaleOrderRestApiService;
  private orderDocService: SaleDocOrderRestApiService;

  // 小程序校验初始化数据接口
  private hrEmployeeService: HrEmployeeService;

  // private curActivity: ProductOnGoingWelfareModel;
  // private curActivityOrder: SaleOrderDTO;

  constructor() {
    super({
      pluginOptions: {
        devTools: {
          name: 'common'
        }
      }
    });
    const api = BfAppContext.getInstance().getApiService();
    // this.productResetService = new ProductProductRestApiService(api);
    // this.productDocGoodsService = new ProductDocGoodsRestApiService(api);
    this.productGoodsService = new ProductGoodsRestApiService(api);
    this.addressService = new ResAddressRestApiService(api);
    this.orderFuncService = new SaleOrderService(api);

    this.customProductGoodsService = new ProductGoodsService(api);

    // this.orderService = new SaleOrderRestApiService(api);
    this.orderDocService = new SaleDocOrderRestApiService(api);
    this.ongoingActivities = new ProductWelfareService(api);

    this.hrEmployeeService = new HrEmployeeService(api);
    this.productCategoryService = new ProductCategoryRestApiService(api);
  }

  public static getInstance(): CommonStore {
    if (!this.instance) {
      this.instance = new CommonStore();
    }
    return this.instance;
  }

  protected getInitialState(): CommonStoreState {
    return {
      ...super.getInitialState(),
      goods: [],
      productType: ProductTypeEnumValue.open_package,
      selectedGoods: [],
      underUpperPriceGoods: [],
      selectedGoodsAmount: 0,
      welfareAmount: 0,
      isContainOpenPackage: false,
      openPackageAmount: 0,
      isContainOpenPackageOk: false,
      cartPopupVisible: false,
      addToCartPopupVisible: false,
      addToCartPopupLoading: false,
      pageNo: 1,
      pageSize: DefaultPageSize,
      pageTotal: 0,
      openPackageProductType: DefaultOpenPackageProductType
    };
  }

  // 员工初始数据
  async checkIfNeedInitData(): Promise<boolean> {
    const rep: HrCheckInitDataModel = await this.hrEmployeeService.checkInitData();
    return rep.needInit;
  }

  // 员工初始数据
  async initData(data: HrInitDataModel) {
    await this.hrEmployeeService.initData(data);
  }

  // 获取当前活动
  async getCurrentActivity() {
    if (this.getState().curActivity) {
      return this.getState().curActivity;
    } else {
      return await this.refreshCurrentActivity();
    }
  }

  // 刷新当前活动
  async refreshCurrentActivity() {
    const currentActivity = await this.ongoingActivities.onGoing();
    this.setState({
      curActivity: currentActivity
    });
    return currentActivity;
  }

  // 获取当前活动的我的订单
  async getMyCurActivityOrder() {
    if (this.getState().myCurActivityOrder) {
      return this.getState().myCurActivityOrder;
    } else {
      return await this.refreshMyCurActivityOrder();
    }
  }

  // 刷新当前活动的我的订单
  async refreshMyCurActivityOrder() {
    try {
      const req = await this.orderFuncService.myWelfareOrder(
        {
          id: this.getState().curActivity.id
        },
        {
          showResErrorMsg: false
        }
      );
      // 工单详情的分组查询返回
      // if (myCurActivityOrder?.isInvoiceFinish) {
      //   orderGoodsTreeData = await this.orderFuncService.detailByGroup({
      //     id: myCurActivityOrder.id
      //   });
      // }

      console.log('reloadMyCurActivityOrder', req);
      this.setState({
        myCurActivityOrder: req
      });
      return req;
    } catch (error) {
      console.log('reloadMyCurActivityOrder error', error);
    } finally {
      //
    }
  }

  // 刷新当前活动的我的额度
  async refreshAmountLimit() {
    try {
      const amountLimit = await this.ongoingActivities.amountLimit({
        id: this.getState().curActivity.id
      });

      this.setState({
        welfareAmount: amountLimit.welfareAmount
      });
      return amountLimit.welfareAmount;
    } catch (error) {
      console.log('reloadMyCurActivityOrder error', error);
    } finally {
      //
    }
  }

  // 获取当前活动的我的额度
  async getAmountLimit() {
    if (this.getState().welfareAmount) {
      return this.getState().welfareAmount;
    } else {
      return await this.refreshAmountLimit();
    }
  }

  // 设置当前活动的我的订单
  setMyCurActivityOrder(order: SaleOrderDTO) {
    this.setState({
      myCurActivityOrder: order
    });
  }

  // getAuditPassCondition
  getAuditPassCondition() {
    // 虽然是不同的接口, 状态的值是一致的, AUDIT_STATUS = "auditStatus";
    // 暂且用ProductDocGoodsRestApiService.AUDIT_STATUS
    return newEqualCondition(ProductDocGoodsRestApiService.AUDIT_STATUS, ProductAuditStatusEnumValue.pass);
  }

  // 获取产品类型枚举
  getProductTypeEnum = async (): Promise<EnumValue[]> => {
    const enumService = BfAppContext.getInstance().getEnumService();
    const enums = await enumService.getEnumOptions(ProductTypeEnumValue._id);

    return enums;
  };

  // 获取零售产品类型枚举
  getOpenPackageProductTypeEnum = async (): Promise<EnumValue[]> => {
    const categories = await this.productCategoryService.query({
      noPaging: true,
      conditions: [newEqualCondition(ProductDocGoodsRestApiService.TYPE, 'open_package')]
    });

    const enums = categories.rows.map((item) => {
      return {
        code: item.id,
        name: item.name
      };
    });

    enums.unshift({
      code: DefaultOpenPackageProductType,
      name: '全部'
    });

    return enums;
  };

  // 获取零售产品类型枚举
  getSaleCardProductTypeEnum = async (): Promise<EnumValue[]> => {
    const suppliers: ResSupplierDTO[] = await this.customProductGoodsService.qrySupplierByType({
      type: {
        code: ProductTypeEnumValue.sale_card
      }
    });

    const enums = Array.isArray(suppliers)
      ? suppliers.map((item) => {
          return {
            code: item.id,
            name: item.name
          };
        })
      : [];

    enums.unshift({
      code: DefaultSaleCardProductType,
      name: '全部'
    });

    return enums;
  };

  // 获取商品列表时的通用条件
  getQueryConditions(productType: string, maxPrice: number) {
    const conditions = [];

    // 当前活动
    conditions.push(newEqualCondition(ProductDocGoodsRestApiService.WELFARE, this.getState().curActivity.id));

    // 产品类型
    if (productType) {
      conditions.push(newEqualCondition(ProductDocGoodsRestApiService.TYPE, productType));
    }

    // 审核通过
    const auditPassCondition = this.getAuditPassCondition();
    conditions.push(auditPassCondition);

    // 加购价格过滤
    if (maxPrice > 0) {
      conditions.push(newRuleCondition(ProductDocGoodsRestApiService.PRICE, maxPrice, ConditionRuleDTO.LE));
    }

    return conditions;
  }

  // 初始化
  async onLoad(params?: CommonLoadParam): Promise<void> {
    console.log('onLoad param: ', params);
    console.log(this.getState());

    this.setLoading(true);

    // 7-根据分类获取供应商列表
    const saleCardProductTypeEnums = await this.getSaleCardProductTypeEnum();

    // 枚举项目
    const enums = await this.getProductTypeEnum();
    const openPackageProductTypeEnums = await this.getOpenPackageProductTypeEnum();
    this.setState({
      productTypeEnum: enums,
      openPackageProductTypeEnums: openPackageProductTypeEnums,
      productType: params?.productType ?? ProductTypeEnumValue.open_package,
      saleCardProductTypeEnums: saleCardProductTypeEnums
    });

    if (params?.productType === RecommondType) {
      this.fetchRecommendGoods('desc', params?.goodId, true);
    } else {
      this.fetchListData(
        this.getQueryConditions(params?.productType ?? ProductTypeEnumValue.open_package, -1),
        [newSortDesc(ProductDocGoodsRestApiService.PRICE)],
        1
      );
    }

    this.setLoading(false);
  }

  /**
   * 过滤
   */
  public onFilterChange = (productType: string) => {
    let conditions = [];

    if (productType && productType !== this.getState().productType) {
      conditions = this.getQueryConditions(productType, -1);
      this.setState({
        productType: productType,
        openPackageProductType: DefaultOpenPackageProductType,
        saleCardProductType: DefaultSaleCardProductType
      });
      if (productType === RecommondType) {
        this.fetchRecommendGoods();
      } else {
        this.fetchListData(conditions, [newSortDesc(ProductDocGoodsRestApiService.PRICE)], 1);
      }
    } else {
      conditions = this.getQueryConditions('', -1);
      this.setState({
        productType: '',
        openPackageProductType: DefaultOpenPackageProductType,
        saleCardProductType: DefaultSaleCardProductType
      });
      this.fetchListData(conditions, [newSortDesc(ProductDocGoodsRestApiService.PRICE)], 1);
    }
  };

  /**
   * 排序
   */
  public onSortChange = () => {
    const productType = this.getState().productType;
    const conditions = this.getQueryConditions(productType, -1);

    if (productType) {
      this.setState({
        productType: productType
      });
    }

    this.priceSort = this.priceSort === 'asc' ? 'desc' : 'asc';

    if (productType === RecommondType) {
      this.fetchRecommendGoods(this.priceSort);
    } else {
      this.fetchListData(
        conditions,
        [
          this.priceSort === 'asc'
            ? newSortAsc(ProductDocGoodsRestApiService.PRICE)
            : newSortDesc(ProductDocGoodsRestApiService.PRICE)
        ],
        1
      );
    }
  };

  /**
   * 零售-通过零售产品类型筛选
   */
  public onOpenPackageProductTypeChange = (typeId: string) => {
    const productType = this.getState().productType;
    const conditions = this.getQueryConditions(productType, -1);

    this.setState({
      openPackageProductType: typeId
    });

    if (typeId === DefaultOpenPackageProductType) {
      this.fetchListData(
        this.getQueryConditions(ProductTypeEnumValue.open_package, -1),
        [newSortDesc(ProductDocGoodsRestApiService.PRICE)],
        1
      );
    } else {
      this.fetchListData(
        conditions.concat([newEqualCondition(ProductGoodsRestApiService.CATEGORY, typeId)]),
        [newSortDesc(ProductDocGoodsRestApiService.PRICE)],
        1
      );
    }
  };

  /**
   * 卡券-通过卡券类型筛选
   */
  public onSaleCardProductTypeChange = (typeId: string) => {
    const productType = this.getState().productType;
    const conditions = this.getQueryConditions(productType, -1);

    this.setState({
      saleCardProductType: typeId
    });

    if (typeId === DefaultSaleCardProductType) {
      this.fetchListData(
        this.getQueryConditions(ProductTypeEnumValue.sale_card, -1),
        [newSortDesc(ProductDocGoodsRestApiService.PRICE)],
        1
      );
    } else {
      this.fetchListData(
        conditions.concat([newEqualCondition(ProductGoodsRestApiService.SUPPLIER, typeId)]),
        [newSortDesc(ProductDocGoodsRestApiService.PRICE)],
        1
      );
    }
  };

  loadMore() {
    if (this.getState().isLoading) {
      return;
    }

    const productType = this.getState().productType;
    let conditions = this.getQueryConditions(productType, -1);
    const openPackageProductType = this.getState().openPackageProductType;

    if (openPackageProductType !== DefaultOpenPackageProductType) {
      conditions = conditions.concat([newEqualCondition(ProductGoodsRestApiService.CATEGORY, openPackageProductType)]);
    }

    if (productType === RecommondType) {
      this.fetchRecommendGoods(this.priceSort);
    } else {
      this.fetchListData(
        conditions,
        [
          this.priceSort === 'asc'
            ? newSortAsc(ProductDocGoodsRestApiService.PRICE)
            : newSortDesc(ProductDocGoodsRestApiService.PRICE)
        ],
        this.getState().pageNo + 1
      );
    }
  }

  async fetchListData(conditions: any, sorts: any, pageNo: number) {
    this.setLoading(true);

    this.setState({
      goods: pageNo === 1 ? [] : this.getState().goods
    });

    const goodsData = await this.productGoodsService.query({
      noPaging: false,
      pageNo: pageNo,
      pageSize: this.getState().pageSize,
      conditions: conditions,
      sorts: sorts
    });

    this.setState({
      goods: pageNo === 1 ? goodsData.rows : this.getState().goods.concat(goodsData.rows),
      pageNo: pageNo,
      pageTotal: goodsData.total
    });
    this.setLoading(false);
  }

  async fetchRecommendGoods(sorts?: any, goodId?: string, isOnload?: boolean) {
    this.setLoading(true);

    // 获取推荐商品
    const conditions = [this.getAuditPassCondition()];
    conditions.push(newEqualCondition(ProductGoodsRestApiService.IS_RECOMMAND, true));
    conditions.push(newEqualCondition(ProductGoodsRestApiService.WELFARE, this.getState().curActivity.id));

    const recommendGoods = await this.productGoodsService.query({
      noPaging: true,
      conditions: conditions,
      sorts: [
        sorts === 'asc'
          ? newSortAsc(ProductDocGoodsRestApiService.PRICE)
          : newSortDesc(ProductDocGoodsRestApiService.PRICE)
      ]
    });

    if (goodId && isOnload) {
      const onLoadSelectGood = recommendGoods.rows.find((item) => item.id.toString() === goodId.toString());
      console.log('onLoadSelectGood', recommendGoods, onLoadSelectGood);
      this.addGoodToCart(onLoadSelectGood, 'recommend');
    }

    this.setState({
      goods: recommendGoods.rows
    });

    this.setLoading(false);
  }

  // 添加到购物车
  async addGoodToCart(newGood: ProductGoodsDTO, type: AddGoodToCartType) {
    // 如过已经有当前活动的订单,不能执行添加操作
    if (this.getState().myCurActivityOrder?.id) {
      this.messageService.showWarn('您已经有当前活动的订单,不能再次添加商品');
      return;
    }

    const amountDiff = this.getState().welfareAmount - this.getState().selectedGoodsAmount;
    if (newGood.price > amountDiff) {
      this.messageService.showWarn('所选商品价格超过限额,请选择其他商品');
      return;
    }

    this.setState((state) => {
      // 查找 selectedGoods 数组中是否已经有了该商品
      const existingGoodIndex = state.selectedGoods?.findIndex((item) => item.good.id === newGood.id);

      if (existingGoodIndex >= 0) {
        // 如果商品已经存在，则更新其数量
        state.selectedGoods[existingGoodIndex].count++;
      } else {
        // 否则创建一个新的商品项
        state.selectedGoods.push({ good: newGood, count: 1 });
      }

      state.selectedGoodsAmount += newGood.price;

      // update state.underUpperPriceGoods
      if (state.underUpperPriceGoods.length > 0) {
        const underPriceGoodsIndex = state.underUpperPriceGoods?.findIndex((item) => item.good.id === newGood.id);
        if (underPriceGoodsIndex >= 0) {
          state.underUpperPriceGoods[underPriceGoodsIndex].count++;
        }
      }

      // 只要购物车里有零售商品 最少满足MIN_OPEN_PACKAGE_AMOUNT
      if (newGood.type.code === ProductTypeEnumValue.open_package) {
        state.isContainOpenPackage = true;
        state.openPackageAmount += newGood.price;
        if (state.openPackageAmount >= MIN_OPEN_PACKAGE_AMOUNT) {
          state.isContainOpenPackageOk = true;
        }
      }

      console.log(state);
      return state;
    });

    // 更新凑单商品列表
    if (type === 'underUpperPrice') {
      const newAmountDiff = amountDiff - newGood.price;
      if (newAmountDiff > 0) {
        await this.getUnderGoods(newAmountDiff, undefined, 'requirement');
      }
    }
  }

  // 从购物车删除商品
  async deleteGoodToCart(good: ProductGoodsDTO, type: DeleteGoodToCartType) {
    const amountDiff = this.getState().welfareAmount - this.getState().selectedGoodsAmount;

    this.setState((state) => {
      // 查找要删除的商品在 selectedGoods 数组中的索引
      const existingGoodIndex = state.selectedGoods?.findIndex((item) => item.good.id === good.id);
      if (existingGoodIndex < 0) {
        return;
      }
      const existingCount = state.selectedGoods[existingGoodIndex].count;

      if (existingCount > 1) {
        state.selectedGoods[existingGoodIndex].count--;
      } else {
        state.selectedGoods.splice(existingGoodIndex, 1);
      }
      state.selectedGoodsAmount -= good.price;

      if (state.underUpperPriceGoods.length > 0) {
        const underPriceGoodsIndex = state.underUpperPriceGoods?.findIndex((item) => item.good.id === good.id);
        if (underPriceGoodsIndex >= 0) {
          state.underUpperPriceGoods[underPriceGoodsIndex].count--;
        }
      }

      // 只要购物车里有零售商品，那么至少有一个必选零售商品
      const existOpenPackage = state.selectedGoods.some(
        (item) => item.good.type.code === ProductTypeEnumValue.open_package
      );

      if (good.type.code === ProductTypeEnumValue.open_package) {
        state.openPackageAmount -= good.price;
        if (state.openPackageAmount >= MIN_OPEN_PACKAGE_AMOUNT) {
          state.isContainOpenPackageOk = true;
        } else {
          state.isContainOpenPackageOk = false;
        }
      }

      if (existOpenPackage) {
        state.isContainOpenPackage = true;
      } else {
        state.isContainOpenPackage = false;
      }

      console.log(state);
      return state;
    });

    console.log(this.getState());

    // 更新凑单商品列表
    if (type === 'underUpperPrice') {
      const newAmountDiff = amountDiff + good.price;
      if (newAmountDiff > 0) {
        this.getUnderGoods(newAmountDiff, undefined, 'requirement');
      }
    }
  }

  // 清空购物车
  async clearCart(useConfirm = true) {
    const confirm = useConfirm ? await this.messageService.showConfirm('确定清空购物车么') : true;
    if (confirm) {
      this.setState((state) => {
        state.selectedGoods = [];
        state.underUpperPriceGoods = [];
        state.selectedGoodsAmount = 0;
        state.underUpperPriceGoods = [];
        state.openPackageAmount = 0;
        state.isContainOpenPackage = false;
        state.isContainOpenPackageOk = false;
        return state;
      });
      this.routeService.back();
    } else {
      return;
    }
  }

  // 加购 凑单
  public getUnderGoods = async (maxPrice: number, productType: string, pageType: 'list' | 'requirement') => {
    this.setState({
      addToCartPopupLoading: true
    });

    this.priceSort = this.priceSort === 'asc' ? 'desc' : 'asc';
    // 零售没凑满就优先零售凑满
    if (!this.getState().isContainOpenPackageOk) {
      productType = ProductTypeEnumValue.open_package;
    }
    const conditions = this.getQueryConditions(productType, maxPrice);

    // TODO: 优化 翻页
    const goodsData = await this.productGoodsService.query({
      noPaging: true,
      conditions: conditions,
      sorts: [newSortDesc(ProductDocGoodsRestApiService.PRICE)]
    });

    this.setState((state) => {
      state.underUpperPriceGoods = goodsData.rows?.map((item) => {
        return {
          good: item,
          count: this.getState().selectedGoods.find((good) => good.good.id === item.id)?.count ?? 0
        };
      });
      state.addToCartPopupLoading = false;
      return state;
    });
  };

  // 获取已选择的商品数量
  getSelectedGoodCount() {
    let count = 0;
    this.getState().selectedGoods.forEach((item) => {
      count += item.count;
    });

    return count;
  }

  /**
   * 获取员工Id
   * @private
   */
  private getMyEmployeeId() {
    return BfAppContext.getInstance().getUserStore().getState().userInfo.employee?.id;
  }

  // 获取默认地址
  async getAddress() {
    this.setLoading(true);

    const address = await this.addressService.query({
      noPaging: true,
      conditions: [
        newEqualCondition(ResAddressRestApiService.EMPLOYEE_ID, this.getMyEmployeeId()),
        newEqualCondition(ResAddressRestApiService.IS_DEF, true)
      ]
    });

    this.setState({
      address: address.rows[0]
    });

    this.setLoading(false);
  }

  // 设定地址
  setAddress(address: ResAddressDTO) {
    this.setState({
      address: address
    });
  }

  // 下单
  async onOrderConfirmClick() {
    const confirm = await this.messageService.showConfirm('确定要提交订单吗?');
    if (!confirm) {
      return;
    }

    if (!this.getState().address?.address) {
      this.messageService.showWarn('请先选择收货地址');
      return;
    }

    if (this.getState().curActivity.choseDeadline && new Date().getTime() > this.getState().curActivity.choseDeadline) {
      this.messageService.showWarn('活动已结束');
      return;
    }

    this.setLoading(true);

    const data: SaleDocOrderDTO = {
      linkman: this.getState().address?.linkmanName,
      linkmanPhone: this.getState().address?.linkmanMobile,
      address: this.getState().address?.address,
      goodsInfo: this.getState().selectedGoods.map((item) => {
        return {
          ...item.good,
          goodsId: { id: item.good.id },
          supplierId: { id: item.good.supplier.id },
          num: item.count
        };
      }),
      welfare: { id: this.getState().curActivity.id }
    };
    try {
      const res = await this.orderDocService.create(data, {
        showResErrorMsg: false
      });

      this.clearCart(false);
      navigationRef.current.navigate(ROUTE_NAMES.HomeIndex, {
        screen: ROUTE_NAMES.GiftGiftShopping,
        params: { orderId: res.id }
      });
      await this.refreshMyCurActivityOrder();
    } catch (e) {
      this.messageService.showWarn(e.message);
    } finally {
      this.setLoading(false);
    }
  }

  // 购物车弹窗是否可见
  setCartPopUpVisible(visible: boolean) {
    this.setState({
      cartPopupVisible: visible
    });
  }

  // 购物车加购弹窗是否可见
  setAddToCartPopupVisible(visible: boolean) {
    this.setState({
      addToCartPopupVisible: visible
    });
  }

  /**
   * 列表点击事件
   * @param item
   */
  async onGoodClick(item: ProductGoodsDTO, mode: 'edit' | 'view') {
    this.routeService.push({
      path: ROUTE_NAMES.GiftGiftInfo,
      query: {
        id: item.id,
        mode: mode
      }
    });
  }
}
